import React from 'react';
import { Accordion } from 'react-bootstrap';
import PageTitle from '../elements/PageTitle';

const accordBlog = [
  {
    // COLUMN 1 – TRAINING & PERFORMANCE
    content: [
      {
        title: "How many days per week should I train to see results?"
      },
      {
        title: "Is lifting weights safe for beginners?"
      },
      {
        title: "How long should a workout session last?"
      },
      {
        title: "Why am I not gaining muscle despite training?"
      },
      {
        title: "Should I train through muscle soreness?"
      },
    ],
  },
  {
    // COLUMN 2 – NUTRITION, FAT LOSS & RECOVERY
    content: [
      {
        title: "Do I need protein supplements to build muscle?"
      },
      {
        title: "Why am I not losing fat even though I work out?"
      },
      {
        title: "Is cardio necessary if my goal is muscle growth?"
      },
      {
        title: "How important is sleep for fitness results?"
      },
      {
        title: "Can I train while following a calorie deficit?"
      },
    ],
  }
];

const Faq = () => {
  return (
    <>
      <div className="page-content bg-white">
        <PageTitle activePage="FAQ" parentTitle="Pages" />

        <section className="content-inner-1 overflow-hidden">
          <div className="container">
            <div className="row">
              {accordBlog.map((data, colIndex) => (
                <div className="col-lg-6" key={colIndex}>
                  <Accordion
                    className="dz-accordion dz-accordion-skew"
                    id={`accordionFaq-${colIndex}`}
                    defaultActiveKey="0"
                  >
                    {data.content.map((item, index) => (
                      <Accordion.Item
                        className="accordion-item"
                        key={index}
                        eventKey={index.toString()}
                      >
                        <Accordion.Header as="h2">
                          {item.title}
                          <span className="toggle-close"></span>
                        </Accordion.Header>

                        <Accordion.Body>
                          <p className="m-b0">
                            Training results depend on consistency, proper technique,
                            recovery, and nutrition. Our coaches recommend focusing on
                            structured workouts, progressive overload, and adequate
                            rest to achieve sustainable progress.
                          </p>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </div>
              ))}
            </div>
          </div>
        </section>


      </div>
    </>
  );
};

export default Faq;
